module.exports = __webpack_public_path__ + "static/media/template5.d038b0ad.png";